import { VueExtension } from '../../utils/extensions/vue';
import TabBarItem from './tabbaritem.jsx';
import './tabbaritem.scss';

VueExtension.WithInstall(TabBarItem);

export default TabBarItem;
